import { patchQueryPart, addQueryPart } from "../shared/queryPartsModel";
import { apiPost } from "../shared/apiClient";

export function disablePart(partId, userId, reason) {
  return patchQueryPart(partId, { userId, status: "disabled", remark: reason });
}

export function enablePart(partId, userId) {
  return patchQueryPart(partId, { userId, status: "active" });
}

// Optional fields are only included when meaningfully present — mirrors the
// exact conditional-spread payload WorkflowTaskDrawer.js built inline.
export function buildAddPartPayload(part, { userId, queryPk }) {
  return {
    part_name: part.part_name.trim(),
    quantity: part.quantity || 1,
    ...(part.side && { side: part.side }),
    ...(part.condition_preference != null && { condition_preference: part.condition_preference }),
    ...(part.part_number?.trim() && { part_number: part.part_number.trim() }),
    userId, query_pk: queryPk,
  };
}

export function addPart(part, { userId, queryPk }) {
  return addQueryPart(buildAddPartPayload(part, { userId, queryPk }));
}

// Appends already-uploaded photo URLs to a live task — WorkflowTaskDrawer's
// "Add Parts" flow calls this after uploading each staged image.
export function appendTaskImages(queryPk, userId, images) {
  return apiPost(`/queryset_v2/${queryPk}/images`, { userId, images }).then(res => res.data);
}
